<div class="ui-search">
	<input
		[class.alt]="design() === 'alt'"
		#searchInput
		type="search"
		autocomplete="off"
		[placeholder]="placeholder() ?? 'Search...'"
		[formControl]="searchControl"
	/>
</div>
